import { __assign } from 'tslib';
import * as React from 'react';

var BigCornerBulgeShape = function (props) {
    return (React.createElement("svg", __assign({ height: "100%", id: "bigCornerBulgeShape", preserveAspectRatio: "none", width: "100%", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("clipPath", { id: "prefix__a" },
            React.createElement("path", { d: "M-737-4039H703v5220H-737z", transform: "matrix(-1 0 0 1 604 0)" })),
        React.createElement("g", { clipPath: "url(#prefix__a)", opacity: 0.44 },
            React.createElement("clipPath", { id: "prefix__b" },
                React.createElement("path", { d: "M223 0h381v359H223z", transform: "matrix(-1 0 0 1 604 0)" })),
            React.createElement("g", { clipPath: "url(#prefix__b)" },
                React.createElement("clipPath", { id: "prefix__c" },
                    React.createElement("path", { d: "M0 0h604v427H0z", transform: "matrix(-1 0 0 1 604 0)" })),
                React.createElement("g", { clipPath: "url(#prefix__c)" },
                    React.createElement("clipPath", { id: "prefix__d" },
                        React.createElement("path", { d: "M223-137h573v496H223z", transform: "matrix(-1 0 0 1 604 0)" })),
                    React.createElement("g", { clipPath: "url(#prefix__d)" },
                        React.createElement("clipPath", { id: "prefix__e" },
                            React.createElement("path", { d: "M315.4-49.486c157.72-76.38 373.017-130.942 448.961-18.13 75.945 112.812-28.35 174.337-90.486 249.729C611.74 257.504 608.528 358 511.01 358c-97.519 0-132.22-48.886-195.61-110.525-63.388-61.64-157.719-220.58 0-296.96z", fillRule: "evenodd", transform: "matrix(-1 0 0 1 604 0)" })),
                        React.createElement("g", { clipPath: "url(#prefix__e)" },
                            React.createElement("clipPath", { id: "prefix__f" },
                                React.createElement("path", { d: "M0 0h604v427H0z", transform: "matrix(-1 0 0 1 604 0)" })),
                            React.createElement("g", { clipPath: "url(#prefix__f)" },
                                React.createElement("path", { d: "M-192-137v500h572v-500z" })))))))));
};

export { BigCornerBulgeShape as default };
//# sourceMappingURL=BigCornerBulgeShape.esm.js.map
